import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/css/admin/dashboardcss/NotificationDropd.css";
import { checkLoggedInAdmin } from "../../../../helper/CustomHelper";

export default function NotificationDropd({ onViewAll, onClose }) {
  const navigate = useNavigate();
  useEffect(()=>{
checkLoggedInAdmin(navigate);
  },[]);
  const { baseUrl } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    checkLoggedInAdmin(navigate);
    viewLatestNotifications();
  }, []);

  const viewLatestNotifications = () => {
    axios
      .get(`${baseUrl}/admin/notifications/viewLatestNotifications`)
      .then((response) => {
        console.log(response.data);
        setNotifications(response.data.notifications);
        setUnreadCount(response.data.count);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const markAllRead = () => {
    axios
      .post(`${baseUrl}/admin/notifications/markAllRead`)
      .then((response) => {
        console.log(response.data);
        viewLatestNotifications();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleViewAll = () => {
    if (onClose) {
      onClose();
    }

    navigate("/admin/notifications");
  };

  return (
    <div className="sgc-nd-overlay" onClick={onClose}>
      <div
        className="sgc-nd-dropdown"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sgc-nd-header">
          <span className="sgc-nd-heading">Notifications</span>

          <button
            className="sgc-nd-mark-all"
            onClick={markAllRead}
          >
            Mark all read
          </button>
        </div>

        {/* List */}
        <ul className="sgc-nd-list">
          {notifications.map((n) => (
            <li
              key={n.id}
              className={`sgc-nd-item ${
                n.is_read === 0
                  ? "sgc-nd-item--unread"
                  : ""
              }`}
            >
              {n.is_read === 0 && (
                <span className="sgc-nd-dot" />
              )}

              <div className="sgc-nd-info">
                <p className="sgc-nd-title">{n.title}</p>
                <p className="sgc-nd-desc">
                  {n.description}
                </p>
              </div>
            </li>
          ))}
        </ul>

        {/* Footer */}
        <div className="sgc-nd-footer">
          <button
            type="button"
            className="sgc-nd-view-all"
            onClick={handleViewAll}
          >
            View all Notifications
          </button>
        </div>
      </div>
    </div>
  );
}